module.exports = __webpack_public_path__ + "static/media/tennising.8eb72513.jpeg";